<template>
    <div class="mt-16" v-if="hasItems">
        <div class="flex flex-col">
            <div class="">
                <div>
                    <div class="p-4">

                        <h3>Details</h3>

                        <ul class="list-reset">
                            <li v-for="(item, index) in items" class="border-t">


                                <edit-series v-slot:default="slotProps" :item="item" :index="index">
                                    <div class="flex text-sm p-4">
                                        <div class="w-3/5">
                                            <a @click="slotProps.open"
                                               class="block p-2 cursor-pointer hover:bg-blue-lightest"
                                               :name="item.name">

                                                {{ item.name }}

                                                <div class="pt-2 text-grey">
                                                    Unit: {{ item.unit }}
                                                </div>

                                            </a>
                                        </div>
                                        <div class="w-2/5 flex">
                                            <div class="w-3/5 p-2 flex">

                                                <div class="w-1/2">
                                                    <span class="text-xs text-grey uppercase tracking-wide">Begin</span><br/>
                                                    {{ item.range.from | limit }}<br>
                                                </div>

                                                <div class="w-1/2">

                                                    <span class="text-xs text-grey uppercase tracking-wide">End</span><br/>
                                                    {{ item.range.to | limit }}
                                                </div>

                                            </div>

                                            <div class="w-2/5 p-2 pt-4 flex justify-end">
                                                <a @click="slotProps.open"
                                                   class="cursor-pointer p-2 hover:text-blue-dark" :name="item.name">
                                                    <i class="fa fa-pencil"></i>
                                                </a>

                                                <a class="cursor-pointer hover:text-red" @click="deleteSeries(index)">
                                                    <i class="fa fa-times"></i>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </edit-series>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import EditSeries from "../components/EditSeries";

    export default {

        components: {EditSeries},

        computed: {
            items() {
                return this.$store.getters.rows;
            },
            hasItems() {
                return this.items.length > 0;
            }
        },

        filters: {
            limit(value) {
                return value.substring(0, 4);
            },
        },

        methods: {
            deleteSeries(index) {
                this.$store.dispatch('deleteSeries', index);
            }
        }
    }
</script>
